/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/logger/ConsoleLogger.ts
 * @create:      2025-06-19 11:21:14.533
 * @modify:      2025-07-11 21:19:12.885
 * @version:     6.0.0
 * @times:       35
 * @lines:       75
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { LogLevel } from "../enum/LogLevel";
import { LogType } from "../enum/LogType";
import { ILogger } from "../interface/ILogger";

/**
 * @since 5.0.0
 * @version 2025-06-20
 */
export class ConsoleLogger implements ILogger {
    public readonly Type = LogType.Console;
    public readonly RespectLevel?: boolean;

    public constructor(respectLevel?: boolean) {
        this.RespectLevel = respectLevel;
    }

    public Write(data: string, level: LogLevel): void {
        if (this.RespectLevel) {
            if (level === LogLevel.Info) {
                // eslint-disable-next-line no-console
                console.info(data);
            }

            if (level === LogLevel.Warn) {
                // eslint-disable-next-line no-console
                console.warn(data);
            }

            if (level === LogLevel.Error) {
                // eslint-disable-next-line no-console
                console.error(data);
            }
        } else {
            // eslint-disable-next-line no-console
            console.log(data);
        }
    }

    public async Dispose(): Promise<void> {
        await Promise.resolve();
    }
}
